import csTranslation from '@/locales/cs/translation.json';
import enTranslation from '@/locales/en/translation.json';
import esTranslation from '@/locales/es/translation.json';
import i18next, { type InitOptions } from 'i18next';

export const SUPPORTED_LANGUAGES = ['en', 'cs', 'es'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const resources = {
    en: { translation: enTranslation },
    cs: { translation: csTranslation },
    es: { translation: esTranslation },
} as const;

const baseConfig: InitOptions = {
    fallbackLng: 'en',
    resources,
    interpolation: {
        escapeValue: false,
    },
    returnNull: false,
    returnEmptyString: false,
};

function getQueryParamLanguage(searchParams: URLSearchParams): SupportedLanguage | null {
    const langParam = searchParams.get('lang') ?? searchParams.get('language');
    if (!langParam) {
        return null;
    }

    const normalized = langParam.toLowerCase();
    return SUPPORTED_LANGUAGES.find((lng) => lng === normalized) ?? null;
}

export function detectLanguage(search: string = window.location.search): SupportedLanguage {
    const params = new URLSearchParams(search);
    return getQueryParamLanguage(params) ?? 'en';
}

export async function initI18n(): Promise<typeof i18next> {
    if (i18next.isInitialized) {
        return i18next;
    }

    const lng = detectLanguage();

    await i18next.init({
        ...baseConfig,
        lng,
    });

    if (typeof document !== 'undefined') {
        document.documentElement.lang = lng;
    }

    return i18next;
}

export default i18next;
